import PlaceholderImage from '../../../atoms/placeholderImage';
import { CarretArrowLeft, CarretArrowRight } from '../../../atoms/icons';
import CustomVideo from '../../customVideoControls';
import defaultStyles from '../ProductGallery.module.scss';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import mergeClasses from '../../../../utils/shallowMerge';
import { Pagination, Navigation } from 'swiper/modules';
import { calcQty, theme } from '../options';
import { Text } from '../../../typography/text/Text';
import { ImageWithOverlay } from '../../../atoms/image/ImageWithOverlay';

const MobileGallery = ({
  images,
  setZoomItem,
  isDemo,
  alt = '',
  customClasses,
  isSelectingSize,
  variant,
  productOverlayUrl,
  isMobile,
}) => {
  const [demoStatus, setDemoStatus] = useState(isDemo);
  const styles = mergeClasses(defaultStyles, customClasses);

  const defaultImages = !images || !images.length ? [{}] : images;

  useEffect(() => {
    if (!images || !images.length) {
      setDemoStatus(true);
    }
  }, []);

  const mainCarouselSettings = {
    spaceBetween: 0,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    loop: true,
    loopedSlides: 5,
    preloadImages: false,
    navigation: {
      prevEl: '.swiper-left-arrow',
      nextEl: '.swiper-right-arrow',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    lazy: {
      checkInView: true,
      loadPrevNext: true,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: true,
    },
    modules: [Pagination, Navigation],
    watchSlidesProgress: true,
  };

  const qtyValue = theme === 'Sportscraft' && calcQty({ isSelectingSize, variant });

  const firstImageIndex = defaultImages.findIndex((x) => !!x.url);
  const hasVideo = defaultImages?.find((x) => !!x?.videoUrl);
  const modifiedArray = [...defaultImages].map((item, index) => {
    return {
      ...item,
      showOverlay: theme === 'jag' ? (isMobile && !hasVideo ? firstImageIndex === index : false) : true,
    };
  });

  const renderImage = (el, shouldPreloadImage) => {
    if (el.videoUrl)
      return (
        <CustomVideo
          videoUrl={el.videoUrl}
          overlayUrl={theme !== 'jag' || isMobile ? productOverlayUrl : null}
          alt={alt}
        />
      );

    return (
      <div
        key={el.id}
        className={`${styles.block} ${!demoStatus && styles.cursorWithDemo}`}
        onClick={() =>
          !demoStatus &&
          setZoomItem({
            enabled: true,
            mainImage: el,
          })
        }
      >
        {!el.url ? (
          <PlaceholderImage className={styles.imageTile} />
        ) : (
          <>
            {qtyValue && theme === 'Sportscraft' && (
              <div className={styles.sizeTextInfoBlock}>
                <Text className={styles.sizeTextInfo} as="p">
                  {qtyValue}
                </Text>
              </div>
            )}

            <ImageWithOverlay
              alt={alt}
              title={alt}
              itemProp="image"
              preloadImage={shouldPreloadImage}
              className={styles.imageTile}
              image={el.url}
              overlayUrl={el?.showOverlay && productOverlayUrl}
              opts={{
                crop: 'fill',
                width: 628,
                height: 785,
              }}
            />
          </>
        )}
      </div>
    );
  };

  const sliders = modifiedArray.map((item, index) => {
    // eslint-disable-next-line array-callback-return
    if (item.type === 'div') return;
    return <SwiperSlide key={`mobile_thumb${index}`}>{renderImage(item, index === 0)}</SwiperSlide>;
  });

  return (
    <div className={`ProductGallery__carouselMobileContainer ` + styles.carouselMobileContainer}>
      <Swiper {...mainCarouselSettings}>{sliders}</Swiper>
      <div
        data-carousel-arrow="arrow_left"
        className={`swiper-left-arrow ${styles.arrowNavigation} ${styles.arrowNavigationLeft}`}
      >
        <CarretArrowLeft />
      </div>
      <div
        data-carousel-arrow="arrow_right"
        className={`swiper-right-arrow ${styles.arrowNavigation} ${styles.arrowNavigationRight}`}
      >
        <CarretArrowRight />
      </div>
      <div className="swiper-pagination" />
    </div>
  );
};

export default MobileGallery;
